export const getCategoryIcon = (
  name: string = 'life',
  size: 22 | 16 = 22,
): string => {
  try {
    return require(`./icons/${size}/${name.toLowerCase()}.svg`);
  } catch (e) {
    console.warn(e);
    return '';
  }
};
